export const RESTAURANTS_IMG_TITLE = 'Let your recipient pick their favorite restaurant!';
export const RESTAURANTS_IMG_URL = '/restaurants.png';
export const RESTAURANTS_DESCRIPTION = '2 million local restaurants';

export const giftCardDefaultTypes = ['choose_your_own_restaurant', 'choose_your_own_spas_and_salons'];

export const giftCardServiceProviderTypes = [
  'choose_your_own_serviceprovider_home',
  'choose_your_own_serviceprovider_personal',
  'choose_your_own_serviceprovider_auto',
];

export const giftCardFlipGiveTypes = [
  'choose_your_own_restaurant_bars',
  'choose_your_own_restaurant_coffee',
  'choose_your_own_restaurants_spas_salons',
];

export const giftCardTypesText: any = {
  choose_your_own_restaurant: 'Restaurants',
  choose_your_own_spas_and_salons: 'Spas & Salons',
  choose_your_own_serviceprovider_home: 'Local Home Services',
  choose_your_own_serviceprovider_personal: 'Local Personal Services',
  choose_your_own_serviceprovider_auto: 'Local Auto Services',
  choose_your_own_restaurant_bars: 'Bars',
  choose_your_own_restaurant_coffee: 'Coffee Shops',
  choose_your_own_restaurants_spas_salons: 'Restaurants, Spas & Salons',
};

export const configurationPageDescriptions: any = {
  choose_your_own_restaurant: '2 million local restaurants',
  choose_your_own_spas_and_salons: '3 million local spas and salons',
  choose_your_own_serviceprovider_home: '7 million local service providers',
  choose_your_own_serviceprovider_personal: '7 million local service providers',
  choose_your_own_serviceprovider_auto: '7 million local service providers',
  choose_your_own_restaurant_bars: '50,000+ local bars',
  choose_your_own_restaurant_coffee: '50,000+ local coffee shops',
  choose_your_own_restaurants_spas_salons: '5 million local restaurants, spas, and salons',
};

export const configurationPageImages: any = {
  choose_your_own_restaurant: '/restaurants.png',
  choose_your_own_spas_and_salons: '/spas-and-salons.png',
  choose_your_own_serviceprovider_home: '/gcm-cyo-home-services.png',
  choose_your_own_serviceprovider_personal: '/gcm-cyo-personal-services.png',
  choose_your_own_serviceprovider_auto: '/gcm-cyo-auto-services.png',
  choose_your_own_restaurant_bars: '/gcm-cyo-bars-configuration.png',
  choose_your_own_restaurant_coffee: '/gcm-cyo-coffee-configuration.png',
  choose_your_own_restaurants_spas_salons: '/gcm-cyo-restaurants-spas-salons-configuration.png',
};

export const configurationPageTitles: any = {
  choose_your_own_restaurant: 'Let your recipient pick their favorite restaurant!',
  choose_your_own_spas_and_salons: 'Let your recipient pick their favorite spa or salon!',
  choose_your_own_serviceprovider_home: 'Let your recipient pick a local service provider!',
  choose_your_own_serviceprovider_personal: 'Let your recipient pick a local service provider!',
  choose_your_own_serviceprovider_auto: 'Let your recipient pick a local service provider!',
  choose_your_own_restaurant_bars: 'Let your recipient pick their favorite bar!',
  choose_your_own_restaurant_coffee: 'Let your recipient pick their favorite coffee shop!',
  choose_your_own_restaurants_spas_salons: 'Let your recipient pick their favorite restaurant, spa and salon!',
};

export const configurationPageServiceCardProgram: any = {
  coffee: 'choose_your_own_restaurant_coffee',
  bars: 'choose_your_own_restaurant_bars',
  favorite: 'choose_your_own_restaurants_spas_salons',
};

export const CartItemImages: any = {
  choose_your_own_restaurant: '/choose-your-own-restaurants-product.png',
  choose_your_own_spas_and_salons: '/choose-your-own-spas-salons-product.png',
  choose_your_own_serviceprovider_home: '/gcm-cyo-home.png',
  choose_your_own_serviceprovider_personal: '/gcm-cyo-personal.png',
  choose_your_own_serviceprovider_auto: '/gcm-cyo-auto.png',
  choose_your_own_restaurant_bars: '/gcm-cyo-bars.png',
  choose_your_own_restaurant_coffee: '/gcm-cyo-coffee.png',
  choose_your_own_restaurants_spas_salons: '/gcm-cyo-restaurants-spas-salons.png',
};